import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AdvancePaymentStatusServiceService } from '@advancedetailcompenent/advance-payment-status/Service/advance-payment-status-service.service';
import { ChaseAdvancePaymentProcessInput } from '@advancedetailcompenent/advance-payment-status/Model/ChaseAdvancePaymentProcessInput';
import { ChaseAdvancePaymentTransactionStatus } from '@advancedetailcompenent/advance-payment-status/Model/ChaseAdvancePaymentTransactionStatus';

@Component({
    selector: 'app-advance-payment-status',
    templateUrl: './advance-payment-status.component.html',
    styleUrls: ['./advance-payment-status.component.css'],
    providers: [AdvancePaymentStatusServiceService],
    standalone: false
})
export class AdvancePaymentStatusComponent implements OnInit {

  constructor(private location: Location, private router: Router, private advancePaymentStatusServiceService: AdvancePaymentStatusServiceService) { }

  uId: string;
  status: string;

  transactionStatus: ChaseAdvancePaymentTransactionStatus = new ChaseAdvancePaymentTransactionStatus();

  ngOnInit() {

    this.location.subscribe(change => {
      if(!change.url.includes("uId"))
        this.router.navigate(['Invoice']);
    });

    this.uId = this.router.parseUrl(this.router.url).queryParams['uId'];



    this.advancePaymentStatusServiceService.getTransactionStatusFromUID(this.uId).subscribe(
      (p: ChaseAdvancePaymentTransactionStatus) => {
        // debugger;
        this.transactionStatus = p;
        if (this.transactionStatus.transactionStatus === 'Success') {
          this.status = 'Success';
        } else {
          this.status = 'Failure';
        }
      });

  }

  home() {
      
    sessionStorage.removeItem('advanceID');
    sessionStorage.removeItem('selectedAccExe');
    sessionStorage.removeItem('comissioncheckbox');
    sessionStorage.removeItem('taxcheckbox');       
    this.router.navigate(['Invoice', 'advance']);
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>MediaPay - Advance Payment</title>
          <style>
          //........Customized style.......
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );

    let btn = popupWin.document.getElementById('goToHome');
    btn.parentNode.removeChild(btn);
    popupWin.document.close();
  }

}
